import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSnackBarComponent } from '../mat-snack-bar/mat-snack-bar.component';
import { PagerService } from 'src/app/Services/pager.service';
import { DatePipe } from '@angular/common';
import { Documents } from 'src/app/Models/AnnualRequirement/ExcelDocuments';
import { VendorDetails } from 'src/app/Models/Admin/vendor-details';
import { VendorDetailService } from 'src/app/Services/admin-rights/vendor-detail.service';
import { VendorFinalizationService } from 'src/app/Services/job-allocation-to-vendors/vendor-finalization.service';
import { element } from '@angular/core/src/render3/instructions';
import { Router } from '@angular/router';
import { ToastrModule, ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-vendor-details',
  templateUrl: './vendor-details.component.html',
  styleUrls: ['./vendor-details.component.css'],
  providers: [DatePipe]
})
export class VendorDetailsComponent implements OnInit {
  vendorDetail: any[] = [];
  model: any[] = [];
  rowCount: any;
  fileNameParts: string[];
  @ViewChild('file') input;
  files: File[] = [];
  fileName: string = '';
  fileType: string;
  loader: string = 'none';
  pageSetting: number = 10;
  modalSetting: number = 0;
  pager: any = {};
  modelDepandent: any[];
  IsFileCorrect: boolean;
  addJobdropdown: any[] = [];
  document: Documents = new Documents();
  displayEditVendor: string = 'none';
  customID: number = 0;
  customActive: boolean = true;
  customName: string = '';
  customType: string = '';
  customNumber: string = '';
  customEmail: string = '';
  customMA: string = '';
  customAddress: string = '';
  customState: string = '';
  vendorTypeDetail: any[] = [];
  roleID : any;
  tryDoctype : any;
  displayPDF : string = 'none';

  constructor(private vendorFinalizationService: VendorFinalizationService, private snackBar: MatSnackBarComponent, private _pagerService: PagerService, private datepipe: DatePipe,
    private router: Router, private vendorDetailService: VendorDetailService,private toastr: ToastrService) {
      this.roleID = localStorage.getItem('mcmt_roleID'); }

  ngOnInit() {
    if (sessionStorage.tabID == undefined) {
      this.router.navigate(['/MCMaterial/Login']);
    }
    this.getVendorDetails();
    this.getVendorDetailDropDown();
  }

  getVendorDetails() {
    console.log(this.roleID);
    this.loader = 'block';
    this.vendorDetailService.getVendorDetails()
      .subscribe((resdata: any) => {
        if (resdata.status == true) {
          this.vendorDetail = resdata.data.vendorDetails;
          this.rowCount = resdata.data.rowCount;
          this.loader = 'none';
        }
        else {
          this.toastr.error(resdata.msg);
          this.loader = 'none';
        }
      })
  }

  vendorTypes() {
    this.loader = 'block';
    this.vendorFinalizationService.vendorTypes()
      .subscribe((resData: any) => {
        if (resData.status == true) {
          this.vendorTypeDetail = resData.data.vendorTypes;
          this.loader = 'none';
        }
        else {
          this.toastr.error(resData.msg);
          this.loader = 'none';
        }
      }
      );
  }

  excelDownload() {
    this.loader = 'block';
    this.vendorDetailService.downloadVendorExcel()
      .subscribe(
        success => {
          var date = new Date();
          let latest_date = this.datepipe.transform(date, 'dd-MMM-yy')
          let Name = localStorage.getItem('mcmt_userName').split(' ');
          let Firstname = Name[0];
          let LastName = Name[1];
          let ExcelName = Firstname + '_' + LastName + '_VendorDetails_' + latest_date + '.xlsx';
          saveAs(success, ExcelName);

          this.loader = 'none';
        },
        err => {
          this.toastr.error("No record/s available");
          this.loader = 'none';
        }
      );
  }



  filesDroppedAdd(files: File[]) {

    this.files = [];
    this.files = files;
    let fileNameParts: string[] = files[0].name.split('.');
    let fileType = files[0].name.split('.')[fileNameParts.length - 1];
    let Name = localStorage.getItem('mcmt_userName').split(' ');
    let Firstname = Name[0];
    let LastName = Name[1];
    let CorrectFileName = Firstname + '_' + LastName + '_VendorDetails_'
    if (fileNameParts[0].includes(CorrectFileName)) {
      this.IsFileCorrect = true;
    }
    else {
      this.IsFileCorrect = false;
    }
    if (fileType != 'xls' && fileType != 'xlsx') {
      this.toastr.error('Please Select Valid File Type.');
      this.loader = 'none';
      this.input.nativeElement.value = null;
      return false;
    }

    this.loader = 'block';
    this.document.file = <File>this.files[0];
    this.vendorDetailService.uploadDocument(this.document.file)
      .subscribe((resData: any) => {
        if (resData.status == true) {
          this.toastr.success(resData.message);
          this.getVendorDetails();
          this.loader = 'none';
          this.input.nativeElement.value = null;
        } else {
          this.toastr.error(resData.message);
          this.loader = 'none';
          this.getVendorDetails();
          this.input.nativeElement.value = null;
        }
        this.files = [];
        this.loader = 'none';
      });
    this.files = files;
    this.fileName = files[0].name;
  }

  addVendor() {
    this.vendorTypes();
    this.displayEditVendor = 'block';
    this.customID = 0;
  }

  editVendor(index: any) {
    this.displayEditVendor = 'block';
    this.customID = this.vendorDetail[index].id;
    this.customActive = this.vendorDetail[index].active;
    this.customName = this.vendorDetail[index].name;
    this.customType = this.vendorDetail[index].type;
    this.customNumber = this.vendorDetail[index].number;
    this.customEmail = this.vendorDetail[index].email;
    this.customMA = this.vendorDetail[index].ma;
    this.customAddress = this.vendorDetail[index].address;
    this.customState = this.vendorDetail[index].state;
  }
  closeVendor() {
    this.displayEditVendor = 'none';
    this.customID = 0;
    this.customName = '';
    this.customType = '';
    this.customNumber = '';
    this.customEmail = '';
    this.customMA = '';
    this.customAddress = '';
    this.customState = '';
  }

  validation(input: string) {
    if (this.customEmail != '') {
      if (this.customNumber != '') {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.customEmail)) {
          if (/^[6-9]\d{9}$/.test(this.customNumber)) {
            if (this.customName != '') {
              if (this.customType != '') {
                if (input == 'Update') {
                  switch (this.customType.toUpperCase()) {
                    case "PRINT VENDOR":
                      {
                        this.customType = '1';
                        break;
                      }
                    case "PRIMARY LOGISTICS VENDOR":
                      {
                        this.customType = '2';
                        break;
                      }
                    case "SECONDARY LOGISTICS VENDOR":
                      {
                        this.customType = '3';
                        break;
                      }
                    default:
                      {
                        this.customType = '0';
                        break;
                      }
                  }

                }
                this.addVendorDetails();
              }
              else {
                this.toastr.error("Mandatory Fields can not be empty");
                this.loader = 'none';
              }
            }
            else {
              this.toastr.error("Mandatory Fields can not be empty");
              this.loader = 'none';
            }
          }
          else {
            this.toastr.error("Invalid Mobile No.");
            this.loader = 'none';
          }
        }
        else {
          this.toastr.error("Invalid Email ID");
          this.loader = 'none';
        }
      }
      else {
        this.toastr.error("Mandatory Fields can not be empty");
        this.loader = 'none';
      }
    }
    else {
      this.toastr.error("Mandatory Fields can not be empty");
      this.loader = 'none';
    }
  }

  addVendorDetails() {
    this.loader = 'block';
    let updateVendor: VendorDetails[] = [];
    var updateDetail = {
      ID: this.customID,
      Active: this.customActive,
      Name: this.customName,
      Type: this.customType,
      Number: this.customNumber,
      Email: this.customEmail,
      MA: this.customMA,
      Address: this.customAddress,
      State: this.customState
    };
    updateVendor.push(updateDetail);
    this.vendorDetailService.updateVendorDetail(updateVendor)
      .subscribe((resdata: any) => {
        if (resdata.status == true) {
          this.getVendorDetails();
          this.displayEditVendor = 'none';
          this.pdfUpload(this.customName);
          this.customID = 0;
          this.customName = '';
          this.customType = '';
          this.customNumber = '';
          this.customEmail = '';
          this.customMA = '';
          this.customAddress = '';
          this.customState = '';
          this.toastr.success(resdata.data[0].msg);
          this.loader = 'none';
        }
        else {
          this.toastr.error(resdata.data[0].msg);
          this.loader = 'none';
          this.displayEditVendor = 'none';
        }
      })
  }

  getVendorDetailDropDown() {
    this.loader = 'block';
    this.vendorDetailService.getVendorDetailDropDown()
      .subscribe((resdata: any) => {
        if (resdata.status == true) {
          this.addJobdropdown = resdata.data;
          this.loader = 'none';
        }
        else {
          this.toastr.error(resdata.msg);
          this.loader = 'none';
        }
      })
  }

  filesAdd(files: File[]) {
    this.files = [];
    this.files = files;
    this.fileNameParts = files[0].name.split('.');
    this.fileType = files[0].name.split('.')[this.fileNameParts.length - 1];
    if (this.fileType != 'pdf') {
      this.toastr.error('Please Select Valid File Type.');
      this.loader = 'none';
      this.input.nativeElement.value = null;
      return false;
    }
  }
  pdfUpload(name : any){
    this.loader = 'block';
    this.document.file = <File>this.files[0];
    this.vendorDetailService.uploadPDFDocument(name, this.document.file)
      .subscribe((resdata: any) => {
        if (resdata.status == true) {
          this.toastr.success('PDF Uploaded Successfully');
          this.loader = 'none';
          this.input.nativeElement.value = null;
        }
        else {
          this.toastr.error('PDF Upload Failed');
          this.loader = 'none';
          this.input.nativeElement.value = null;
        }
      })
  }

  pdfDownload(index: any) {
    var VendorName = this.vendorDetail[index].name.replace(' ', '')
    this.loader = 'block';
    this.vendorDetailService.downloadPDFDocument(VendorName)
      .subscribe(
        success => {
          //let ExcelName = VendorName + '.pdf';
          //saveAs(success, ExcelName);
          let fileURL = URL.createObjectURL(success);
          this.tryDoctype = fileURL
          this.displayPDF = 'block';
          this.loader = 'none';
        },
        err => {
          this.toastr.error("No record/s available");
          this.loader = 'none';
        }
      );
  }

  closePDF(){
    this.displayPDF = 'none';
  }
}
